import { render, staticRenderFns } from "./collapsible.vue?vue&type=template&id=273308d3&scoped=true"
import script from "./collapsible.vue?vue&type=script&lang=js"
export * from "./collapsible.vue?vue&type=script&lang=js"
import style0 from "./collapsible.vue?vue&type=style&index=0&id=273308d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273308d3",
  null
  
)

export default component.exports